import { createSelector } from '@reduxjs/toolkit';
import isEmpty from 'lodash/isEmpty';
import { selectors as dataGridTableSelectors } from '../Modules/dataGridTable';
import { selectors as filterSelectors } from '../Modules/filters';
import { transform as transformList } from 'utils/DataTransform/SecurityCompanies/pendingComapniesList';
import { transform as transformDetails } from 'utils/DataTransform/SecurityCompanies/pendingCompanyDetails';
import { getCountryList, getTimezone } from 'reducers/utils';

export const getPendingCompanyList = createSelector(
  dataGridTableSelectors.getGridTableList,
  getCountryList,
  getTimezone,
  (pendingCompanies, countryList, timeZone) => {
    if (isEmpty(pendingCompanies)) {
      return [];
    }
    return transformList(pendingCompanies, countryList, timeZone);
  },
);
export const getForceRefresh = createSelector(
  dataGridTableSelectors.getForceRefresh,
  forceRefresh => forceRefresh,
);
export const getTotalEntries = createSelector(
  dataGridTableSelectors.getTotalGridRows,
  rowsCount => {
    if (!rowsCount) {
      return 0;
    }
    return rowsCount;
  },
);
export const getFilters = createSelector(
  filterSelectors.getFilterValues,
  filterValues => {
    return filterValues;
  },
);
export const getPendingCompanyDetails = createSelector(
  dataGridTableSelectors.getGridRowDetails,
  getCountryList,
  (securityCompany, countryList) => {
    if (!securityCompany) {
      return {};
    }
    return transformDetails(securityCompany, countryList);
  },
);
export const isPendingStatus = createSelector(
  dataGridTableSelectors.getGridRowDetails,
  item => {
    if (!item || !item.status) {
      return false;
    } else if (item.status === 'PENDING') {
      return true;
    }
    return false;
  },
);
export const getPendingCompanyTitle = createSelector(
  dataGridTableSelectors.getGridRowDetails,
  details => {
    if (!details || !details.status) return '';
    return `${details.status} Company Details`;
  },
);
